/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};

// ====================================== 商品订单 ================================
//
exports.saveProxyGoodsOrder = function (postData, callback) {// 保存代理下单（商品订单）
    api.post('/goods/order/proxy/save/do')
    .data(postData)
    .done(callback)
    .go();
};

//查询订单
exports.getGoodsOrderList = function (params, callback) {// 获取商品订单分页列表
    api.post('/goods/order/list/get')
    .data(params)
    .done(callback)
    .go();
};

exports.getGoodsOrderInfo = function (postData, callback) {// 获取商品订单信息
    api.post('/goods/order/info/get')
    .data(postData)
    .done(callback)
    .go();
};

//订单动作
exports.doCancelGoodsOrder = function (postData, callback) {// 订单动作处理
    api.post('/goods/order/cancel/do')
    .data(postData)
    .done(callback)
    .go();
};

// =========================== 配货管理 ==========================================

//获取code
exports.getDeliverCodeByContractId = function (params, callback) {// 获取合同交易过程发货方式code
    api.post('/goods/order/tradePhase/deliver/code/get')
    .data(params)
    .done(callback)
    .go();
};

exports.getOrderGoodsAllocItemSumInfoListByOrderIdAndBuyerShopId = function (postData, callback) {// 根据orderId和skuId获取配货信息列表
    api.post('/goods/order/alloc/item/sumInfo/list/get/by/orderId/and/buyerShopId')
    .data(postData)
    .done(callback)
    .go();
};

// 配货单列表
exports.getOrderGoodsAllocFormList = function (params, callback) {// 配货单列表
    api.post('/goods/order/alloc/form/list/get')
    .data(params)
    .done(callback)
    .go();
};

exports.getOrderGoodsAllocItemListByOrderId = function (postData, callback) {// 获取配货信息分页列表
    api.post('/goods/order/alloc/item/list/get/by/orderId')
    .data(postData)
    .done(callback)
    .go();
};
// 配货单项列表信息
exports.getOrderGoodsAllocItemListByAllocFormId = function (params, callback) {// 配货单项列表
    api.get('/goods/order/alloc/form/item/list/get')
    .params(params)
    .done(callback)
    .go();
};
exports.getOrderGoodsAllocItemList = function (postData, callback) {// 获取配货信息列表
    api.post('/goods/order/alloc/item/list/get')
    .data(postData)
    .done(callback)
    .go();
};
exports.getOrderGoodsAllocDtoListByOrderId = function (postData, callback) {// 获取店铺配货信息列表
    api.post('/goods/order/alloc/dto/list/get/by/orderId')
    .data(postData)
    .done(callback)
    .go();
};
exports.getOrderGoodsAllocFormListByOrderId = function (postData, callback) {// 获取店铺配货信息列表
    api.post('/goods/order/alloc/form/list/get/by/orderId')
    .data(postData)
    .done(callback)
    .go();
};

exports.getOrderGoodsRecvAddrByShopIdAndOrderId = function (postData, callback) {// 查询订单中是否有选中的店铺
    api.get('/goods/order/recv/addr/get/by/shopId/and/orderId')
    .params(postData)
    .done(callback)
    .go();
};

exports.getGoodsOrderItemList = function (postData, callback) {// 获取商品订单项列表
    api.post('/goods/order/item/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//配货
exports.saveOrderGoodsAllocItems = function (postData, callback) {// 批量保存配货信息
    api.post('/goods/order/alloc/items/save/do')
    .data(postData)
    .done(callback)
    .go();
};
// 调减
exports.reduceGoodsAllocItemDo = function (postData, callback) {
    api.post('/goods/order/alloc/item/reduce/do')
    .data(postData)
    .done(callback)
    .go();
};

// 作废操作
exports.invalidateOrderGoodsAllocItem = function (postData, callback) {// 批量保存配货信息
    api.post('/goods/order/alloc/item/invalidate/do')
    .data(postData)
    .done(callback)
    .go();
};

//=======================================================================

//查询相同合同的订单商品数量
exports.getGoodsOrderItemQuantityByContractNoAndSkuId = function (params, callback) {// 查询相同合同的订单中商品数量
    api.post('/goods/order/item/quantity/get/by/contractNo/and/skuId')
    .data(params)
    .done(callback)
    .go();
};

//====================================================================================

// ================== 商品订单操作记录 ====================
exports.getGoodsOrderRecordList = function (params, callback) {// 获取订单操作记录分页列表
    api.post('/goods/order/record/list/get')
    .data(params)
    .done(callback)
    .go();
};

//=================== 评价 ======================

// 获取评价列表
exports.getOrderGoodsEvalList = function (params, callback) {// 获取所有的评价分页列表
    api.post('/goods/order/order/goods/eval/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 评价详细信息
exports.getOrderGoodsEvalInfo = function (params, callback) {// 查询评价信息
    api.post('/goods/order/order/goods/eval/info/get')
    .data(params)
    .done(callback)
    .go();
};

// 商品订单改价
exports.updateGoodsOrderItemDiscount = function (params, callback) {// 作废配货信息
    api.post('/goods/order/item/discount/update')
    .data(params)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/goodsOrder.js
// module id = 61
// module chunks = 1